import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    
    :root{
        --color-white: #fff;
        --color-black: #000;
        --color-light-blue: #c3ddfd;
        --color-light-blue-rgb: 195,221,253;
        --color-blue: #009ada;
        --color-blue-rgb: 0,154,218;
        --color-dark-blue: #233876;
        --color-dark-blue-rgb: 35,56,118;
        --color-blue-gray: #7e8299;
        --color-blue-gray-rgb: 126,130,153;
        --color-light-blue: #ebf6ff;
        --color-light-blue-rgb: 235,246,255;
        --color-gray: #f4f4f5;
        --color-gray-rgb: 244,244,245;
        --color-gray--50: #f9fafb;
        --color-gray--50-rgb: 249,250,251;
        --color-gray--100: #f3f4f6;
        --color-gray--100-rgb: 243,244,246;
        --color-gray--200: #e5e7eb;
        --color-gray--200-rgb: 229,231,235;
        --color-gray--400: #9ca3af;
        --color-gray--400-rgb: 156,163,175;
        --color-gray--500: #6b7280;
        --color-gray--500-rgb: 107,114,128;
        --color-gray--600: #4b5563;
        --color-gray--600-rgb: 75,85,99;
        --color-gray--900: #111928;
        --color-gray--900-rgb: 17,25,40;
        --color-yellow: #faca15;
        --color-pink: #f17eb8;
        --color-pink--200: #f542a7;
        --color-teal: #16bdca;
        --color-indigo: #8da2fb;
        --color-orange: #ff8a4c;
        --color-orange--50: #fff8f1;
        --color-green: #31c48d;
        --color-red: #e02424;
    }

    html,
    body {
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        color: var(--color-gray--900);
        background-color: var(--color-gray--50);
    }

    body {
        font-family: 'Inter', Helvetica, Arial, sans-serif;
    }

    #app {
        min-height: 100%;
        min-width: 100%;
    }

    #icons{
        display: none;
    }


    @-webkit-keyframes loadingAnim {
        0%{
            background-position: -100% 0
        }
        100%{
            background-position: 100% 0
        }
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
    
`;
